import { useMemo } from 'react'
import { OnboardingState } from '../../hooks/use-onboarding-setup'
import { OnboardingStepKey, OnboardingStepStatus } from '@cbgms/api'

// useShouldExecuteStep return whether or not the step should execute. It might still not be shown to the user and execute in the background
export const useShouldExecuteStep = (step: OnboardingStepKey, onboardingInfo: OnboardingState): boolean => {
  return useMemo(() => {
    const matchedStep = onboardingInfo.stepData.find(s => s.Key === step)
    return shouldExecute(matchedStep?.State || OnboardingStepStatus.Off)
  }, [step, onboardingInfo.stepData])
}

const shouldExecute = (status: OnboardingStepStatus) => {
  if (status === OnboardingStepStatus.Background) return true
  if (status === OnboardingStepStatus.PreFill) return true

  return false
}
